export const SET_TRIGGER = 'SET_TRIGGER';
export const ADD_CONDITION = 'ADD_CONDITION';
export const REMOVE_CONDITION = 'REMOVE_CONDITION';
export const UPDATE_CONDITION = 'UPDATE_CONDITION';
export const UPDATE_SCHEDULE_CONDITION = 'UPDATE_SCHEDULE_CONDITION';
export const UPDATE_TRIGGER_CONDITIONS = 'UPDATE_TRIGGER_CONDITIONS';
export const UPDATE_AUDIENCE_CONDITIONS = 'UPDATE_AUDIENCE_CONDITIONS';
export const UPDATE_TARGET_CONTACT_TYPES = 'UPDATE_TARGET_CONTACT_TYPES';
